import React, { useState, useEffect } from 'react';
import '../../css/activateOffers.css';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import imgActivateOffers from '../../assets/img/onboarding/desktop/img-acumule-saldo-codigo-referal-desktop-tablet.png';
import imgActivateOffersMobile from '../../assets/img/onboarding/mobile/img-acumule-saldo-codigo-referal-mobile.png';
import IconNotifySuccess from '../../assets/svg/mainIconNotifySuccess.svg';              
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { AiOutlineStop } from "react-icons/ai";
import { FiCheckCircle } from "react-icons/fi";
import { errorHandling } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionId, setCookieId, setClientId } from '../../features/onboardingData/onboardingUserData';
function ActivateOffers() {

    const [isLoading, setIsLoading] = useState(true);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);
    const isSessionId = useSelector((state) => state.onboardingUserData.isSessionId);
    const isCookieId = useSelector((state) => state.onboardingUserData.isCookieId);
    const isClientId = useSelector((state) => state.onboardingUserData.isClientId);
    const [offerCode, setOfferCode] = useState('');
    const [isStartingLoadingDots, setIsStartingLoadingDots] = useState(false)
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [isValidReferral, setIsValidReferral] = useState(true);
    const [isFocused, setIsFocused] =  useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        setIsFocused(false);
    };

    const fetchCSRFToken = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_DEV_URL}/csrf-token`, {
            credentials: "include",
            mode: 'cors'
          });
          const data = await response.json();
          const csrfToken = data.csrfToken;
    
          return csrfToken;
        } catch (error) {
          errorHandling('CSRF');
        }
    };

    const hadleBtnClickRefresh = () => {
        const delay = setTimeout(() => {
            window.location.reload(false); 
        }, 5000); 

        return () => clearTimeout(delay); 
    };

    const getApplyCode = async () => {
        try {
            setIsStartingLoadingDots(true);
            const csrfToken = await fetchCSRFToken();
            const response = await fetch(`${process.env.REACT_APP_DEV_URL}/applyCode/fetchApplyCode`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'PT-PT',
                'CookieId': `${isCookieId}`,
                'SessionId': `${isSessionId}`,
                'ClientId': `${isClientId}`,
                "xsrf-token": csrfToken,
            },
            credentials: "include",
            mode: "cors",
            body: JSON.stringify({ code: offerCode }),
            });
            if (response.ok === false) {
                errorHandling(response.status);
                return;
            }
            const result = await response.json();
            if (result.erroMsg === 'Success') {
                setIsValidReferral(true);
                toast.success("Código adicionado! O saldo da Carteira Virtual será atualizado dentro de momentos.",  {
                    icon: <img src={IconNotifySuccess} alt="icon" className="toast_iconNotifySuccess" />
                });
                setIsStartingLoadingDots(false);
                setOfferCode('')
                hadleBtnClickRefresh();
            } else {
                setIsValidReferral(false);
                setIsStartingLoadingDots(false);
            }
        } catch (error) {
            setIsStartingLoadingDots(false);
            setIsValidReferral(false);
            if (!navigator.onLine) {
                errorHandling('NoInternet');
            } else if (error instanceof TypeError && error.message === "Failed to fetch") {
                errorHandling('CORS');
            } else {
                errorHandling();
            }
        }
    }

    const inputClassName = isTablet ? 
    (isValidReferral ? 'inputTextActivateOffers' : 'inputTextActivateOffersInvalid') : ( isMobile ?
        (isValidReferral ? 'inputTextActivateOffersTablet' : 'inputTextActivateOffersTabletInvalid')
        :
        (isValidReferral ? 'inputTextActivateOffersMobile' : 'inputTextActivateOffersInvalidMobile'));

    const inputClassNameFocus  = isTablet ? 
    (isValidReferral ? 'inputTextActivateOffers focused' : 'inputTextActivateOffersInvalid focused') : ( isMobile ?
        (isValidReferral ? 'inputTextActivateOffersTablet focused' : 'inputTextActivateOffersTabletInvalid focused')
        :
        (isValidReferral ? 'inputTextActivateOffersMobile focused' : 'inputTextActivateOffersInvalidMobile focused'));
    
    return (
        <>
        { !isTablet && (
            <>
            <div className={ isMobile ? 'mainImgViewActivateOffersTablet' : 'mainImgViewActivateOffersMobile'}>
                <img src={imgActivateOffers} alt="imagem" className={ isMobile ? "mainImgActivateOffersTablet" : "mainImgActivateOffersMobile"} />
            </div>
            </>
        )}
        <div className={ isTablet ? 'secondMainContainerActivateOffers' : ( isMobile ? 'secondMainContainerActivateOffersTablet' : 'secondMainContainerActivateOffersMobile') }>
            <div className={ isTablet ? 'firstSubMainContainerActivateOffers'  : ( isMobile ? 'firstSubMainContainerActivateOffersTablet' : 'firstSubMainContainerActivateOffersMobile') }>
                <div className='secondTitleViewActivateOffers'>
                    <span><b className={ isTablet ? 'textTitleBold700ActivateOffers' : ( isMobile ? 'textTitleBold700ActivateOffersTablet' : 'textTitleBold700ActivateOffersMobile' ) }>Transforme o código </b></span>
                    <span className={ isTablet ? 'textTitleRegular400ActivateOffers' : ( isMobile ? 'textTitleBold700ActivateOffersTablet' :  'textTitleRegular400ActivateOffersMobile' )}>em saldo</span>      
                </div>
                <div className='txtSecondTitleViewActivateOffers'>
                    <div className={ isTablet ? 'textSecondTitleViewActivateOffers' : ( isMobile ? 'textSecondTitleViewActivateOffersTablet' : 'textSecondTitleViewActivateOffersMobile' )}>Insira aqui o código da campanha ou promoção que recebeu e acumule saldo na Carteira Virtual.</div>
                </div>
                <div className={ isTablet ? 'textFormViewActivateOffers' : 'textFormViewActivateOffersMobile' }>
                    <div className={ isTablet ? 'textWrapperActivateOffers' : 'textWrapperActivateOffersMobile' }>
                        { (isFocused || offerCode.length > 0) &&
                        <label className='label-focus'>Insira aqui o seu código</label>
                        }
                        <input 
                            className={ offerCode.length > 0 ? inputClassNameFocus : inputClassName}
                            type="text" 
                            placeholder={!isFocused ? 'Insira aqui o seu código' : undefined}
                            value={offerCode}
                            onChange={(event) => setOfferCode(event.target.value)}
                            maxLength={30}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                                                        
                        />
                    </div>
                    { !isValidReferral &&
                        <div className='txtViewErrorInfoActivateOffers'>
                            <div className='txtErrorInfoActivateOffers'><AiOutlineStop className='iconErrorInfoActivateOffers'/> Não conseguimos validar o seu código. Por favor, verifique se o mesmo está ativo e se tem um cartão bancário associado.</div>
                        </div>
                    } 
                </div>
                <div className={ isTablet ? 'btnViewActivateOffers' : 'btnViewActivateOffersMobile' }>
                    <CustomButton
                        text={'Validar'}
                        textColor={'#00214D'}
                        onPress={getApplyCode}
                        enabled={!offerCode.length <= 0}
                        color={'#15D4B6'}
                        hasArrow
                        iconType={'check'}
                        iconColor={'#00214D'}
                        loading={isStartingLoadingDots}
                    />
                </div> 
            </div>
            { isTablet && (
                <>
                <div className='mainImgViewActivateOffers'>
                    <img src={imgActivateOffersMobile} alt="imagem" className="mainImgActivateOffers" />
                </div>
                </>
            )}
        </div>   
        </>       
    )
}

export default ActivateOffers